import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Grid,
  withStyles,
  Typography,
} from '@material-ui/core';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { CSVLink } from 'react-csv';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { setLastPage } from 'shared/services/authService';
import {
  getCandidateSummary,
  clearSummary,
} from 'shared/services/summaryService';
import {
  getTableRowPerPageFromStorage,
  setLocalStorage,
} from 'shared/utils/localStorage';
import { ActionButtonJobllegroRoundedInline } from 'shared/utils/styledComponents';
import AtsEmptyContainer from '../../components/AtsEmptyContainer';
import DefaultSearchField from '../../components/DefaultSearchField';
import PageHeader from '../../components/PageHeader';
import SummaryLeftDescription from '../../components/SummaryLeftDescription';
import SummaryCellComponent from './components/SummaryCellComponent';
import SummaryRowComponent from './components/SummaryRowComponent';

let columnData = [
  {
    id: 'lastName',
    numeric: false,
    label: 'summary:candidateField.name',
    hiddenSm: 'false',
    hiddenXs: 'false',
  },
  {
    id: 'stage1',
    numeric: true,
    label: 'summary:candidateField.stage1Title',
    hiddenSm: 'true',
    hiddenXs: 'true',
  },
  {
    id: 'stage2',
    numeric: true,
    label: 'summary:candidateField.stage2Title',
    hiddenSm: 'true',
    hiddenXs: 'true',
  },
  {
    id: 'stage3',
    numeric: true,
    label: 'summary:candidateField.stage3Title',
    hiddenSm: 'true',
    hiddenXs: 'true',
  },
  {
    id: 'stage4',
    numeric: true,
    label: 'summary:candidateField.stage4Title',
    hiddenSm: 'false',
    hiddenXs: 'true',
  },
  {
    id: 'stage5',
    numeric: true,
    label: 'summary:candidateField.stage5Title',
    hiddenSm: 'false',
    hiddenXs: 'true',
  },
  {
    id: 'stage6',
    numeric: true,
    label: 'summary:candidateField.stage6Title',
    hiddenSm: 'false',
    hiddenXs: 'false',
  },
  {
    id: 'rejected',
    numeric: true,
    label: 'summary:candidateField.rejected',
    hiddenSm: 'false',
    hiddenXs: 'false',
  },
];

const styles = theme => ({
  rootPaper: theme.mixins.gutters({
    paddingTop: 0,
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    paddingBottom: 16,
    marginTop: 0,
  }),
  root: {
    marginTop: 8,
  },
  paperContainer: {
    paddingTop: 56,
    paddingLeft: 64,
    paddingRight: 64,
    [theme.breakpoints.down('md')]: {
      paddingTop: 16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  paperContainerSection: {
    display: 'flex',
    height: 50,
    alignItems: 'center',
    paddingTop: 32,
    paddingBottom: 0,
    paddingLeft: 24,
    paddingRight: 24,
    [theme.breakpoints.down('md')]: {
      paddingTop: 16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  tableRow: {
    borderTop: `1px solid ${theme.palette.jobllegroBorderGrey}`,
    paddingTop: 0,
    paddingBottom: 0,
    height: '40px',
  },
  sectionTitle: {
    color: '#52a3fc',
    fontSize: 18,
    fontWeight: '500',
    marginRight: 10,
  },
});

export class CandidateSummaryViewHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { t, order, orderBy, classes } = this.props;

    columnData = columnData.map((column, index) => {
      return { ...column, label: t(column.label) };
    });

    return (
      <TableHead>
        <TableRow className={classes.tableRow}>
          {columnData.map((column, index) => (
            <SummaryCellComponent
              index={index}
              key={column.id}
              column={column}
              orderBy={orderBy}
              order={order}
              onClickTrigger={this.createSortHandler(column.id)}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }
}

CandidateSummaryViewHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export class CandidateSummaryIndexView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: 'desc',
      orderBy: 'id',
      page: 0,
      rowsPerPage: getTableRowPerPageFromStorage(this.props.match.url) || 10,
      filterString: '',
      isLoading: true,
      anchorEl: null,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    this.reloadSummary({ [this.props.match.params.filter]: true });
    this.interval = setInterval(() => {
      this.props.match.params.filter
        ? this.reloadSummary({ [this.props.match.params.filter]: true })
        : this.reloadSummary();
    }, 30000);
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
    this.props.clearSummary();
  }

  reloadSummary = async filter => {
    if (this._isMounted) {
      this.setState({ isLoading: true });
    }
    await this.props.getCandidateSummary(filter);
    if (this._isMounted) {
      this.setState({ isLoading: false });
    }
  };

  async componentWillReceiveProps(nextProps) {
    this.props.setLastPage(nextProps.location.pathname);
    if (nextProps.match.params !== this.props.match.params) {
      this.setState({
        rowsPerPage: getTableRowPerPageFromStorage(this.props.match.url) || 10,
      });
      nextProps.match.params.filter
        ? this.reloadSummary({ [nextProps.match.params.filter]: true })
        : this.reloadSummary();
    }
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (!orderBy) {
      return;
    }

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy, page: 0 });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    setLocalStorage(this.props.match.url, event.target.value);
    this.setState({ rowsPerPage: event.target.value });
  };

  setFilterString = value => {
    this.setState({
      filterString: value,
    });
  };

  render() {
    const { t, summaryList = [], classes } = this.props;
    const { order, orderBy, rowsPerPage, page, filterString } = this.state;

    let data = _.filter(summaryList, candidate => {
      let filter = false;
      _.forOwn(candidate, field => {
        filter =
          filter ||
          (field &&
            _.includes(
              field.toString().toLowerCase(),
              filterString.toLowerCase()
            ));
      });
      return filter;
    });

    data = _.sortBy(data, orderBy);
    //działa odwrotnie bo material-ui/Table ma przy asc strzałkę w górę
    data = order === 'asc' ? _.reverse(data) : data;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <React.Fragment>
        <PageHeader title={t('summary:menu.candidateSummaryTitle')} />
        <Grid container alignItems="flex-start" spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12} className={classes.root}>
            <Paper className={classes.rootPaper} elevation={0}>
              <Grid container alignItems="flex-start" spacing={0}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Paper className={classes.paperContainer} elevation={0}>
                    <SummaryLeftDescription params="recruiter" />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Paper
                    className={classes.paperContainerSection}
                    elevation={0}
                  >
                    <Typography variant="h5" className={classes.sectionTitle}>
                      {t('summary:menu.summaryTitle')}
                    </Typography>
                    <ActionButtonJobllegroRoundedInline>
                      <CSVLink
                        data={data}
                        filename={'candidateSummaryExport.csv'}
                      >
                        {t('core:action.download') + ' Csv'}
                      </CSVLink>
                    </ActionButtonJobllegroRoundedInline>
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} align="flex-end">
                  <Paper
                    className={classes.paperContainerSection}
                    elevation={0}
                  >
                    <DefaultSearchField
                      placeholder={t('summary:searchCandidateBarTitle')}
                      onChangeHandler={this.setFilterString}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {data.length === 0 ? (
                    <AtsEmptyContainer
                      text={t('summary:candidatesListEmpty')}
                    />
                  ) : (
                    <Table>
                      <CandidateSummaryViewHead
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={this.handleRequestSort}
                        classes={classes}
                        t={t}
                      />
                      <TableBody>
                        {data
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map(n => {
                            return <SummaryRowComponent key={n.id} data={n} />;
                          })}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 49 * emptyRows }}>
                            <TableCell colSpan={columnData.length + 1} />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            labelRowsPerPage={t('pagination.elementsPerPage')}
                            labelDisplayedRows={({ from, to, count }) =>
                              t('pagination.pagesFromTo', { from, to, count })
                            }
                            colSpan={columnData.length + 1}
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            page={page}
                            backIconButtonProps={{
                              'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                              'aria-label': 'Next Page',
                            }}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  )}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    summaryList: store.summary.list,
  };
};

const mapDispatchToProps = {
  getCandidateSummary,
  clearSummary,
  setLastPage,
};

CandidateSummaryIndexView.propTypes = {
  summaryList: PropTypes.array.isRequired,
  getCandidateSummary: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CandidateSummaryIndexView)));
